import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic';
import type { Nullable, OptionalProps, RemoveIndex } from '../../../types/helpers';

export enum ProductPromotionClass {
    ORDER = 'ORDER',
    PRODUCT = 'PRODUCT',
    SHIPPING = 'SHIPPING',
}

export type ProductPromotion = Omit<
    OptionalProps<RemoveIndex<ShopperProductsTypes.ProductPromotion>, 'promotionalPrice'>,
    'calloutMsg'
> & {
    details?: Nullable<string>;
    promotionClass?: ProductPromotionClass;
    tags?: string[];
    calloutMsg?: Nullable<string>;
};
